import React from 'react';
import { createRoot } from 'react-dom/client';
import 'dotenv/config';
import 'index.scss';
import App from 'client/App';

import '@fontsource/roboto/400.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/700-italic.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App/>);
